import moment from 'moment';

export const getMoment = (value) => {
    return value ? moment(value) : moment()
}

export function getDayOfWeek(date) {
    return new Date(date).toLocaleDateString('en-US', {weekday: 'long', timeZone: 'UTC'});
}